"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createPeriodicImprovementPerformance = exports.createPeriodicImprovementCreative = exports.createPeriodicImprovementValues = exports.createPeriodicImprovementValue = void 0;
const creation_1 = require("../creation");
const PerformanceValue_1 = require("../DailyPerformanceValue/PerformanceValue");
const performanceReportPeriod_1 = require("./performanceReportPeriod");
const createPeriodicImprovementValue = ({ metric = 'click_through_rate', target = 'all', targetValue = PerformanceValue_1.createPerformanceValue(), actualValue = PerformanceValue_1.createPerformanceValue(), } = {}) => ({
    metric,
    target,
    targetValue,
    actualValue,
});
exports.createPeriodicImprovementValue = createPeriodicImprovementValue;
const createPeriodicImprovementValues = ({ all = [exports.createPeriodicImprovementValue()], staticImage = [exports.createPeriodicImprovementValue()], video = [exports.createPeriodicImprovementValue()], } = {}) => ({
    all,
    staticImage,
    video,
});
exports.createPeriodicImprovementValues = createPeriodicImprovementValues;
const createPeriodicImprovementCreative = ({ creativeId = '', adName = '', thumbnailImageUrl = '', values = exports.createPeriodicImprovementValues(), creation = creation_1.createSomeCreation(), } = {}) => ({
    creativeId,
    adName,
    thumbnailImageUrl,
    values,
    creation,
});
exports.createPeriodicImprovementCreative = createPeriodicImprovementCreative;
const createPeriodicImprovementPerformance = ({ period = performanceReportPeriod_1.createPerformanceReportPeriod(), creatives = [exports.createPeriodicImprovementCreative()], } = {}) => ({
    period,
    creatives,
});
exports.createPeriodicImprovementPerformance = createPeriodicImprovementPerformance;
